import resolve from '../../../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../../../modules/apiHelper';

export default {
  async getProgramPillars(context, data) {
    const result = await resolve(apiPost('company-pillars', generateFormData(data), 7)).then((res) => {
      if (!res) return false;
      // console.log(data);

      const companyPillars = res['company-pillars'] || [];

      return companyPillars;
    });

    return result;
  },

  async getProgramGoals(context, data) {
    const result = await resolve(apiPost('company-goals', generateFormData(data), 7)).then((res) => {
      if (!res) return false;
      // console.log(data);

      const companyGoals = res['company-goals'] || [];

      return companyGoals;
    });

    return result;
  },

  async saveProgramPillarGroup(context, data) {
    const createPillar = async () => {
      const pillarReq = await resolve(apiPost(
        'add_pillar',
        generateFormData({
          pillar_name: data.name,
          companyid: data.companyId,
          progid: data.programId,
        }),
        7,
      ));

      return pillarReq;
    };

    const updatePillar = async () => {
      const pillarrNameReq = resolve(apiPost(
        'edit_pillar_name',
        generateFormData({
          pillar_name: data.name,
          pillarid: data.groupId,
        }),
        7,
      ));

      // const pillarGroupReq = resolve(apiPost(
      //   'edit_pillar_company',
      //   generateFormData({
      //     pillarid: data.groupId,
      //     companyid: data.companyId,
      //   }),
      //   7,
      // ));

      const result = await Promise.all([
        pillarrNameReq,
        // pillarGroupReq,
      ]);

      return result;
    };

    let result;

    if (data.groupId) {
      // updating
      result = await updatePillar();
    } else {
      // creating
      result = await createPillar();
    }

    // console.log(result);

    return result;
  },

  async saveProgramGoal(context, data) {
    const createGoal = async () => {
      const goalReq = await resolve(apiPost(
        'add_goal',
        generateFormData({
          goal_name: data.name,
          groupid: data.groupId,
          companyid: data.companyId,
          progid: data.programId,
          desc: data.description,
        }),
      ));

      return goalReq;
    };

    const updateGoal = async () => {
      const goalGroupReq = resolve(apiPost(
        'edit_goal_pillar',
        generateFormData({
          goalid: data.goalId,
          pillarid: data.groupId,
        }),
        7,
      ));

      const goalNameReq = resolve(apiPost(
        'edit_goal_name',
        generateFormData({
          goalid: data.goalId,
          goal: data.name,
        }),
      ));

      const goalDescReq = resolve(apiPost(
        'edit_goal_desc',
        generateFormData({
          goalid: data.goalId,
          desc: data.description,
        }),
      ));

      const result = await Promise.all([
        goalGroupReq,
        goalNameReq,
        goalDescReq,
      ]);

      console.log(result);

      return result.every((r) => !!r);
    };

    let result;

    if (data.goalId) {
      // updating
      result = await updateGoal();
    } else {
      // creating
      result = await createGoal();
    }

    // console.log(result);

    return result;
  },
};
